import store from "../index";
import { getInitialState as comparePage } from "../compare-page.module"
import { getInitialState as myAdmin } from "../my-admin.module"
import { getInitialState as myDocuments } from "../my-documents.module"
import { getInitialState as mySupport } from "../my-support.module"
import { getInitialState as parametricSearch } from "../parametricsearch.module"
import { getInitialState as recomendedDriver } from "../recommended-driver.module"
import { getInitialState as userManagement } from "../user-management.module"

const initialStateCopy = JSON.parse(JSON.stringify(
{
        comparePage: comparePage(),
        myAdmin: myAdmin(),
        myDocuments: myDocuments(),
        mySupport: mySupport(),
        parametricSearch: parametricSearch(),
        recomendedDriver: recomendedDriver(),
        userManagement: userManagement()
}));

export function resetState () {
    store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)));
}
